import apiClient, { setAuthToken } from './api.client';

const ensureAuth = () => {
  const tk = localStorage.getItem('token');
  if (tk) setAuthToken(tk);
};

const handleError = (err) => {
  if (err && err.response && err.response.status === 401) {
    const e = new Error('Unauthorized');
    e.status = 401;
    throw e;
  }
  throw err;
};

const TableService = {
  list: async (accountId) => {
    try {
      ensureAuth();
      const res = await apiClient.get(`/account/${accountId}/tables`);
      return res.data;
    } catch (err) {
      handleError(err);
    }
  },

  create: async (accountId, data) => {
    try {
      ensureAuth();
      const res = await apiClient.post(`/account/${accountId}/tables`, data);
      return res.data;
    } catch (err) {
      handleError(err);
    }
  },

  update: async (tableId, data) => {
    try {
      ensureAuth();
      const res = await apiClient.patch(`/account/tables/${tableId}`, data);
      return res.data;
    } catch (err) {
      handleError(err);
    }
  },

  remove: async (tableId) => {
    try {
      ensureAuth();
      const res = await apiClient.delete(`/account/tables/${tableId}`);
      return res.data;
    } catch (err) {
      handleError(err);
    }
  },
};

export default TableService;
